import { useQuery } from "@tanstack/react-query";
import { GatewayService } from "../api/gateway.service";
import type { Client } from "@shared-types";

/** State and actions returned by {@link useClientById}. */
export interface UseClientByIdReturn {
    data: Client | undefined;
    loading: boolean;
    error: Error | null;
    /** Re-run the query for the current client id. */
    refetch: () => void;
}

/**
 * Fetch a single client by id.
 *
 * The query stays disabled while `clientId` is null/undefined.
 */
export const useClientById = (clientId: number | string | null | undefined): UseClientByIdReturn => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["gateway", "client", clientId],
        queryFn: ({ signal }) => GatewayService.getClientById(Number(clientId), { signal }),
        enabled: Boolean(clientId),
    });
    // See useClients.ts — drop the react-query Promise so we honour the
    // `() => void` public interface.
    return {
        data,
        loading: isLoading,
        error,
        refetch: () => { void refetch(); },
    };
};
